import FbService from 'FB';
import { api as Api } from 'utils';
import { helper } from 'utils';
import {
  appAuthToken,
  setTokenCode,
  removeStoredAuthToken,
  removeAppAuthToken,
  removeTokenCode,
} from 'utils/auth';
import config from 'config';

export const status = {
  error: 'E',
  success: 's',
};

export const storeUserLogin = async ({ fbUser, ton }) => {
  try {
    const params = { eUy: fbUser?.id, ton, aVn: Number(process.env.REACT_APP_VERSION) };
    const [{ login }, error] = await helper.asyncWrapper(() => Api('POST', config.api.login, params));
    if (error) throw error;
    const { lTn } = login.plr;
    appAuthToken(lTn);
    ton && setTokenCode(ton);
    return login;
  } catch (error) {
    removeStoredAuthToken();
    removeAppAuthToken();
    removeTokenCode();
  }
};

export const appUserLogin = async tokenCode => {
  return tokenCode ? await storeUserLogin({ ton: tokenCode }) : FbService.login();
};

export const getStoreData = async params => {
  const response = await Api('POST', config.api.store, params);
  const isValidResponse = 'ims' in response;
  const isValidStatus = isValidResponse && response.ims.sts === 's';
  if (!isValidStatus) throw new Error('FAILED - invalid store data.');
  return response.ims.ims;
};

export const claimDynamicBonus = async params => {
  const { claimDynamicBonus } = await Api('POST', config.api.claimDynamicBonus, params);
  return claimDynamicBonus;
};

const appService = {
  storeUserLogin,
  appUserLogin,
  getStoreData,
  claimDynamicBonus,
};

export default appService;
